import React from "react";

import Spinner from "../spinner";

/**
 * Holds an edit popup's form back until the record it opened for has loaded
 * (`useEditLoad`): a spinner while it loads, the error if it failed, the form
 * once it is there. Never the previous record's form.
 */
const EditLoadGate = ({ ready, error, children }) =>
  ready ? (
    children
  ) : (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "240px" }}>
      {error ? <p className="error-message d-block m-0">{error}</p> : <Spinner />}
    </div>
  );

export default EditLoadGate;
